const indexItems = [
  {
    title: '本周热榜',
    desc: '触手漫画热度TOP20精选',
    icon: 'ri-fire-line',
    color: 'primary',
  },
  {
    title: '新作上架',
    desc: '最新触手漫画速递尝鲜',
    icon: 'ri-sparkling-line',
    color: 'accent',
  },
  {
    title: '完结佳作',
    desc: '触手漫画完结精选合集',
    icon: 'ri-check-double-line',
    color: 'secondary',
  },
  {
    title: '编辑推荐',
    desc: '编辑精选触手漫画必看',
    icon: 'ri-star-line',
    color: 'primary',
  },
  {
    title: '奇幻专区',
    desc: '异世界触手漫画大合集',
    icon: 'ri-magic-line',
    color: 'accent',
  },
  {
    title: '热血战斗',
    desc: '燃向触手漫画热血推荐',
    icon: 'ri-sword-line',
    color: 'secondary',
  },
  {
    title: '悬疑惊悚',
    desc: '烧脑触手漫画专题精选',
    icon: 'ri-ghost-line',
    color: 'primary',
  },
  {
    title: '轻松日常',
    desc: '治愈系触手漫画暖心推荐',
    icon: 'ri-heart-line',
    color: 'accent',
  },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-600',
    border: 'hover:border-primary-300',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-600',
    border: 'hover:border-accent-300',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-600',
    border: 'hover:border-secondary-300',
  },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 scroll-mt-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按主题发现你喜欢的触手漫画
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => {
            const c = colorMap[item.color];
            return (
              <a
                key={item.title}
                href="#cards"
                className={`group flex flex-col items-center text-center bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 ${c.border} transition-colors cursor-pointer`}
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center ${c.bg} ${c.text} rounded-xl mb-3 text-xl md:text-2xl`}
                >
                  <i className={item.icon}></i>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 group-hover:text-primary-500 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}